import React from "react";
import { LinkTile } from "idc-ui-react";
// Fabric
import { Stack, Text } from "@fluentui/react";

const QuickLinks = ({ links }) => {
  return (
    <Stack
      horizontal
      verticalAlign="top"
      styles={{
        root: {
          minHeight: 100,
          backgroundColor: "transparent",
          marginBottom: 10,
          paddingTop: 10,
          flexWrap: "wrap"
        }
      }}
    >
      {links.length
        ? links.map(link => (
            <Text
              style={{
                flex: 1,
                flexWrap: "wrap",
                flexDirection: "row",
                margin: 10
              }}
              key={link.id}
            >
              <LinkTile link={link} size="xLarge" />
            </Text>
          ))
        : ""}
    </Stack>
  );
};

export default QuickLinks;
